import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ServerSelectInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // if (!request.url.includes("/i18n/")) {
      if (!request.url.includes("/i18n/")
      &&!request.url.includes("/SAPMicroService/api/delivery?")

      )
       {//please remember to change it back after work is done
      const versionedReq = request.clone({
        // url: `/api/${environment.apiVersion}${request.url}`
        url: `/api${request.url}`
      })
      return next.handle(versionedReq)
    }
    else {
      const versionedReq = request.clone({
        url: `${request.url}`
      })
      return next.handle(versionedReq)
    }

  }
}
